import { Box, Image, SimpleGrid } from "@chakra-ui/react";
import React from "react";

export default function ImageSlider() {
  const [image, setImage] = React.useState("/images/gigImage/gig-1.png");
  return (
    <Box pb={10}>
      <Image
        src={image}
        w="full"
        border="1px solid #c5c5c5"
        borderRadius={"0px 0px 10px 10px"}
      />
      <SimpleGrid columns={3}>
        {imageData.map((item) => {
          return (
            <Image
              key={item}
              src={item}
              border="1px solid #707070"
              borderRadius={10}
              overflow={"hidden"}
              m={0}
              onClick={() => {
                setImage(item);
              }}
              opacity={image !== item && 0.4}
              cursor="pointer"
            />
          );
        })}
      </SimpleGrid>
    </Box>
  );
}
const imageData = [
  "/images/gigImage/gig-1.png",
  "/images/marketplace-category/logo/logo-2.png",
  "/images/marketplace-category/logo/logo-3.png",
];
